// import "@babel/polyfill";
import "@babel/polyfill/noConflict";
import 'bootstrap';
import 'bootstrap/js/dist/util';
import './acreedge-app.scss'
window.jQuery = require('jquery');
import './js/script.js'
